import type { TeamType } from '@rhythmic/types'
import type { Ref, UseLiveQueryReturn } from '@tanstack/vue-db'
import { eq, useLiveQuery } from '@tanstack/vue-db'
import { TEAM_TABLE } from '../collections'
import { useCollection } from '../composables/useCollection'

/**
 * Live teams query scoped to a specific workspace slug.
 */
export function useTeamsByWorkspaceSlug(workspaceSlug: string | undefined): UseLiveQueryReturn<TeamType> | undefined {
  if (!workspaceSlug) return undefined

  const collection = useCollection<TeamType>(TEAM_TABLE, {
    workspace_slug: workspaceSlug,
  }).collection

  const isCurrentSlug = ({ t }: { t: Ref<TeamType> }) => eq(t.workspace_slug, workspaceSlug)

  return useLiveQuery(
    (builder) => {
      return builder
        .from({ t: collection })
        .where(isCurrentSlug)
        .orderBy(({ t }) => t.name, 'asc')
    },
    [workspaceSlug],
  )
}
